/**
 * @Description: 稿件功能常量
 * @author zhaijiayu
 * @date 2021/8/23
*/

// 稿件类型
export const MANUSCRIPT_TYPE = {
    0: '全部',
    1: '文章',
    2: '视频',
    3: '图集'
}

// 稿件审核状态
export const MANUSCRIPT_AUDIT_STATUS = {
    1: '内部审核中',
    2: '审核失败',
    3: '审核通过'
}

// 发布渠道名称
export const APP_NAME_MAP = {
    1: '微信公众平台',
    2: '微信小程序',
    3: '抖音App',
    4: '头条号',
    5: '百家号',
    6: '企鹅号',
    7: '西瓜视频App',
    8: '今日头条APP授权抖音平台',
    9: '河南日报客户端',
    10: '大河网',
    11: '大河财立方',
    31: '大河云媒体'
}

// 素材审核状态
export const MATERIAL_AUDIT_STATUS = {
    0: '全部',
    1: '未审核',
    4: '审核中',
    2: '审核通过',
    3: '审核失败'
}

export const UPLOAD_SUPPORT_MIME = [
    'image/gif',
    'image/jpeg',
    'image/jpg',
    'image/png',
    'image/svg',
    // 视频
    // 'video/mp4',
    // 'video/x-flv',
    // 'video/quicktime',
    // 'video/x-msvideo',
    //文稿
    // 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    // 'application/msword',
    // 'text/plain'
]

export const MANUSCRIPT_STATUS = [{
    id: 20,
    name: '全部'
}, {
    id: 7,
    name: '已发布'
}, {
    id: 5,
    name: '审核中'
}, {
    id: 6,
    name: '未通过'
}, {
    id: 4,
    name: '仅我可见'
}, {
    id: 12,
    name: '定时发布'
}, {
    id: 13,
    name: '已下线'
}]

export const MANUSCRIPT_VIDEOPACK_STATUS = [{
    id: -1,
    name: '全部'
}, {
    id: 6,
    name: '已发布'
}, {
    id: 0,
    name: '审核中'
}, {
    id: 7,
    name: '未通过'
}]

export const MANUSCRIPT_LIST_STATUS_DETAIL = {
    1: '内部审核中',
    2: '审核中',
    3: '内部审核不通过',
    4: '审核中',
    5: '已发布',
    8: '未通过',
}

export const MANUSCRIPT_LIST_STATUS = {
    1: '审核中',
    0: '已发布',
    2: '未通过',
}

export const POST_LIST_STATUS_DETAIL = {
    1: '已发布',
    2: '已发布',
    3: '未通过',
    4: '未通过',
}

export const SHORT_PLAY_STATUS_DETAIL = [{
    id: "",
    name: '全部'
}, {
    id: "6",
    name: '已发布'
}, {
    id: "0,1,4,5",
    name: '审核中'
}, {
    id: "7",
    name: '未通过'
}]

export const DEFAULT_COVER = {
    test: 'obs.dingxinwen.cn/video/20220626/418340ff283445e5cb60b040c6f7cef8.jpg',
    online: 'obs.dingxinwen.cn/video/20220626/418340ff283445e5cb60b040c6f7cef8.jpg'
}[process.env.API_ENV]
